/* global localStorage */

import axios from 'axios';
import { router } from '@/router'
import store from '@/store';
import { getAccessToken } from '@/backend/storage'
import i18n from '@/lang'

const API_URL = process.env.API_URL

const needForceUpgrade = (headers) => {
  return (
    headers !== undefined &&
    headers['x-web-upgrade'] === 'true' &&
    semver.gt(headers['x-web-version'], store.getters['version/current'])
  )
}

const errorMessage = (data) => {
  let type = 'danger'
  let content = i18n.t('messages.cannotAccess')

  if (typeof data !== 'object') {
    return { type: type, content: content }
  } else {
    return {
      type: data.type || type,
      content: data.message || content
    }
  }
}

var instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

instance.interceptors.response.use(
  function (response) {
    let headers = response.headers;

    if (needForceUpgrade(headers)) {
      store.dispatch('version/outdated', headers['x-web-version']);
    }

    // continue sending response to the then() method
    return Promise.resolve(response)
  },
  function (error) {
    // check if unauthorized error returned
    const routeExceptions = ['SignUpForm', 'CandidateJoinEntities']

    if (error.response && error.response.status === 401) {
      store.dispatch('auth/signOut')
      if (router.currentRoute.name != 'SignUpForm') {
        router.replace({ name: 'SignInForm' })
      }
    } else if (error.response && (error.response.status === 403 || (error.response.status === 404 && !routeExceptions.includes(router.currentRoute.name)))) {
      router.replace({ name: 'Dashboard' })
      store.dispatch('message/enable', errorMessage(error.response.data))
    }

    // request is rejected and will direct logic to the catch() method
    return Promise.reject(error)
  }
)

instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers['Authorization'] = 'Bearer ' + getAccessToken();
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default instance



// WEBPACK FOOTER //
// ./src/backend/vue-axios/axios.js